import { string, bool, func } from 'prop-types';
import { Route, Routes } from 'react-router-dom';
import { mskRoutes } from '../scripts/routes';

// This function returns a component of child routes for the action plan so that the consuming app
// only needs to set up the parent route.
const VirtualMSKActionPlanRoutes = ({
	apiEnv,
	ssId,
	pathToActionPlanRoutes,
	apiToken,
	memberId,
	isAdmin,
	navigateToResourceLibrary,
}) => (
	<Routes>
		{mskRoutes.map(route => {
			// props to be passed to this route
			const routeProps = {
				apiEnv,
				ssId,
				pathToActionPlanRoutes,
				apiToken,
				memberId,
				isAdmin,
				navigateToResourceLibrary,
			};

			return (
				<Route
					key={route.href}
					path={route.href}
					element={<route.component {...routeProps} />}
				/>
			);
		})}
	</Routes>
);

VirtualMSKActionPlanRoutes.propTypes = {
	/*
	 * The environment the component is being hosted on such as "prod" or "dev".
	 */
	apiEnv: string.isRequired,
	/*
	 * Session ID to be added to the header when calling the API.
	 */
	ssId: string.isRequired,
	/*
	 * pathToActionPlanRoutes: string that leads to where action plan routes are mounted. Eg. if you mounted actionPlanRoutes at `/actionPlan`, you would pass "/actionPlan"
	 */
	pathToActionPlanRoutes: string,
	/**
	 * apiToken to be added to the header for the video player to call domain specific endpoints to decrypt the encrypted resource
	 */
	apiToken: string.isRequired,
	/*
	 * Member ID to be added to the header when calling the API.
	 */
	memberId: string,
	/*
	 * Flag to indicate to the component if the consumer is an admin site
	 */
	isAdmin: bool,
	/*
	 * Consumer passed callback to navigate to resource library
	 */
	navigateToResourceLibrary: func.isRequired,
};

VirtualMSKActionPlanRoutes.defaultProps = {
	pathToActionPlanRoutes: '',
	isAdmin: false,
	memberId: '',
};

export default VirtualMSKActionPlanRoutes;
